export const POSTITS = [
  {
    color: "bg-yellow-300",
    token: "J",
    text:
      "ODD (Objectifs de Développement Durable)\n" +
      "Bien-être au travail\n" +
      "• Limiter les réunions tardives\n" +
      "Réu équipe produit sur le sujet lundi matin\n" +
      "→ Prévoir salle + 3 cafés\n\n" +
      "",
  },
  {
    color: "bg-pink-300",
    token: "R",
    text:
      "Démo: vendredi après midi à 5h\n" +
      "ODD – Consommation responsable\n" +
      "• Couper les visios quand ce n’est pas utile\n" +
      "• Garder seulement ce qui sert vraiment à la démo" +
      "",
  },
  {
    color: "bg-blue-300",
    token: "B",
    text:
      "ODD – Numérique & infra\n" +
      "Réunion sécu salle 9: mots de passe\n" +
      "→ arrêter qwerty, etc.\n" +
      "• Ne pas multiplier les copies de données\n" +
      "• Documenter les incidents (sans tout logguer à vie)" +
      "",
  },
  {
    color: "bg-green-300",
    token: "V",
    text:
      "Mettre à jour la slide \n" +
      "2 du support de conf call\n" +
      "(plus de \"Vous m'entendez ?\" à répétition)\n\n" +
      "",
  },
];